"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var styled_components_1 = require("styled-components");
var useClickOutside_1 = __importDefault(require("../../hooks/useClickOutside"));
var Typography_1 = __importDefault(require("../Typography"));
var icon_1 = __importDefault(require("./icon"));
var styles_1 = require("./styles");
var Checkbox = function (_a) {
    var checked = _a.checked, label = _a.label, onToggle = _a.onToggle, disabled = _a.disabled, testId = _a.testId, props = __rest(_a, ["checked", "label", "onToggle", "disabled", "testId"]);
    var _b = (0, react_1.useState)(false), isFocused = _b[0], setIsFocused = _b[1];
    var containerRef = (0, react_1.useRef)(null);
    var _c = (0, styled_components_1.useTheme)(), colors = _c.colors, checkbox = _c.checkbox;
    var handleFocus = function () {
        if (!disabled) {
            setIsFocused(true);
        }
    };
    var handleBlur = function () {
        setIsFocused(false);
    };
    var handleClick = function () {
        if (!disabled) {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            setIsFocused(true);
        }
    };
    (0, useClickOutside_1.default)(containerRef, handleBlur);
    // Create a descriptive aria-label
    var ariaLabel = props['aria-label'] || (label === null || label === void 0 ? void 0 : label.toString()) || '';
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ onClick: handleClick, ref: containerRef, className: (0, classnames_1.default)({ disabled: disabled }), "data-testid": "".concat(testId, "-checkbox-container") }, props, { children: [(0, jsx_runtime_1.jsxs)(styles_1.CheckboxContainer, { children: [checked ? ((0, jsx_runtime_1.jsx)(styles_1.CheckedBox, __assign({ className: (0, classnames_1.default)({ focused: isFocused, disabled: disabled }), "data-testid": "".concat(testId, "-checkbox-input") }, { children: (0, jsx_runtime_1.jsx)(icon_1.default, { color: disabled ? colors.text.neuGray500 : checkbox.checkedStroke }) }))) : ((0, jsx_runtime_1.jsx)(styles_1.UncheckedBox, { className: (0, classnames_1.default)({ focused: isFocused, disabled: disabled }), "data-testid": "".concat(testId, "-checkbox-input") })), (0, jsx_runtime_1.jsx)(styles_1.CheckboxInput, { type: "checkbox", defaultChecked: checked, onFocus: handleFocus, onBlur: handleBlur, "data-testid": "".concat(testId, "-checkbox-hidden-input"), className: (0, classnames_1.default)({ disabled: disabled }), "aria-label": ariaLabel, "aria-checked": !!checked, "aria-disabled": !!disabled })] }), (0, jsx_runtime_1.jsx)(Typography_1.default.Body, __assign({ size: "lg", bold: checked, color: disabled ? colors.text.neuGray500 : undefined, "data-testid": "".concat(testId, "-checkbox-label") }, { children: label }))] })));
};
exports.default = Checkbox;
